import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { ModalController } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { Observable } from "rxjs/Rx";
import { Hareline } from "../../models/interfaces/hareline.model";
import { Member } from "../../models/interfaces/member.model";
import { HarelineAddPage } from "../../pages/hareline/hareline_add";
import { HarelineViewPage } from "../../pages/hareline/hareline_view";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-hareline",
  templateUrl: "hareline.html",
})

export class HarelinePage {
  public static readonly HARELINE_ADD_ACCESS = "addHareline";
  private exportViewName = "vw_export_hareline";
  private exportFileName = "Hareline";
  private currentUser: Member;
  private avg_cost: number;
  private hasAddHarelineAccess: boolean = false;
  private hare;
  private hareline$: any;
  private hareline = [];
  private hareline_all = [];
  private hareline_past = [];
  private hareline_future = [];
  private hl_id: string;
  private keys_future: string[];
  private keys_past: string[];
  private presentMonth = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate()).toISOString().substring(0, 10);
  private pastMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 12 , new Date().getDate()).toISOString().substring(0, 10);
  private showFuture: boolean = true;
  private showPast: boolean = false;
  private styleName: string ="";
  private colorVar: string = "color:rgb(141, 216, 145)";
  private tmp_hareline_past = [];
  private tmp_hareline_future = [];
  private runScore: number;
  private zippedFuture: boolean = false;
  private zippedPast: boolean = true;

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController,
    private db: DbserviceProvider, public modalCtrl: ModalController,
  ) {
    console.log("HarelinePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.hasAddHarelineAccess = this.db.hasAccess(HarelinePage.HARELINE_ADD_ACCESS);
  }

  private ionViewWillEnter() {
    console.log("HarelinePage ionViewWillEnter");
    if (this.authService.currentUser) {
      this.hasAddHarelineAccess = this.db.hasAccess(HarelinePage.HARELINE_ADD_ACCESS);
    }
    this.onInitPage();
  }

  private onInitPage() {
    console.log("HarelinePage onInitPage");
    this.hareline = [];
    this.tmp_hareline_past = [];
    this.tmp_hareline_future = [];
    this.db.dbCol({
      "action": "select", "mapObject": "vw_expenses_avg_365",
    }).subscribe((x) => {
      this.avg_cost = parseInt(x[0].avg);
      this.db.dbCol({
        /* "action": "select", "mapObject": "vw_hareline", "sqlExtended": "  where hl_datetime >= '" + this.pastMonth + */
        "action": "select", "mapObject": "vw_hareline", "sqlExtended": "   order by hl_datetime desc"
      })
        .subscribe((ret) => {
          this.hareline_all = ret;
          ret.forEach((el) => {
            if (this.hareline[el.hl_id] === undefined || this.hareline[el.hl_id] == null) {
              this.hareline[el.hl_id] = [];
            }
            this.hareline[el.hl_id].hl_id = el.hl_id;
            this.hareline[el.hl_id].hl_runno = el.hl_runno;
            this.hareline[el.hl_id].hl_datetime = el.hl_datetime;
            this.hareline[el.hl_id].hl_runsite = el.hl_runsite;
            this.hareline[el.hl_id].hl_gps = el.hl_gps;
            this.hareline[el.hl_id].hl_runtype = el.hl_runtype;
            this.hareline[el.hl_id].hl_guestfee = el.hl_guestfee;
            this.hareline[el.hl_id].hl_comment = el.hl_comment;
            this.hareline[el.hl_id].hl_jm_comment = '';
            this.hareline[el.hl_id].hl_jm_comment = el.hl_jm_comment;
            this.hareline[el.hl_id].hl_length = el.hl_length;
            this.hareline[el.hl_id].ex_amount_ttl = el.ex_amount_ttl;
            this.hareline[el.hl_id].avg_cost = this.avg_cost;
            this.hareline[el.hl_id].hc_icon = el.hc_icon;
            this.hareline[el.hl_id].hc_icon_color = el.hc_icon_color;
            this.runScore = (el.ex_amount_ttl - this.avg_cost) / el.ex_amount_ttl;

            if (this.runScore <= -0.2 && this.hareline[el.hl_id].ex_amount_ttl) {
              this.hareline[el.hl_id].is_money_icon1_visible = true;
            } else if (this.runScore <= -0.1 && this.runScore > -0.2 && this.hareline[el.hl_id].ex_amount_ttl) {
              this.hareline[el.hl_id].is_money_icon1_visible = true;
              this.hareline[el.hl_id].is_money_icon2_visible = true;
            }
            else if (this.runScore <= 0.1 && this.runScore > -0.1 && this.hareline[el.hl_id].ex_amount_ttl) {
              this.hareline[el.hl_id].is_money_icon1_visible = true;
              this.hareline[el.hl_id].is_money_icon2_visible = true;
              this.hareline[el.hl_id].is_money_icon3_visible = true;
            }
            else if (this.runScore <= 0.2 && this.runScore > 0.1 && this.hareline[el.hl_id].ex_amount_ttl) {
              this.hareline[el.hl_id].is_money_icon1_visible = true;
              this.hareline[el.hl_id].is_money_icon2_visible = true;
              this.hareline[el.hl_id].is_money_icon3_visible = true;
              this.hareline[el.hl_id].is_money_icon4_visible = true;
            }
            else if (this.runScore > 0.2 && this.hareline[el.hl_id].ex_amount_ttl) {
              this.hareline[el.hl_id].is_money_icon1_visible = true;
              this.hareline[el.hl_id].is_money_icon2_visible = true;
              this.hareline[el.hl_id].is_money_icon3_visible = true;
              this.hareline[el.hl_id].is_money_icon4_visible = true;
              this.hareline[el.hl_id].is_money_icon5_visible = true;
            }
            if (el.hc_icon == null) {
              this.hareline[el.hl_id].is_runcategory_icon_visible = false;
            }
            else {
              this.hareline[el.hl_id].is_runcategory_icon_visible = true;
              this.hareline[el.hl_id].is_runner_icon_visible = false;
            }
            if (this.hareline[el.hl_id].ex_amount_ttl == null) {
              this.hareline[el.hl_id].is_runner_icon_visible = true;
              this.hareline[el.hl_id].is_money_icon_visible = false;
            } else {
              this.hareline[el.hl_id].is_runner_icon_visible = false;
              this.hareline[el.hl_id].is_money_icon_visible = true;
            }

            if (this.hareline[el.hl_id][el.hs_id] === undefined || this.hareline[el.hl_id][el.hs_id] == null) {
              this.hareline[el.hl_id][el.hs_id] = [];
            }
            this.hareline[el.hl_id][el.hs_id].hs_id = el.hs_id;
            this.hareline[el.hl_id][el.hs_id].mb_id = el.mb_id;
            this.hareline[el.hl_id][el.hs_id].hl_id = el.hl_id;
            this.hareline[el.hl_id][el.hs_id].hs_type = el.hs_type;

            if (el.hs_type === "H") {
              if (this.hareline[el.hl_id].hl_hare === undefined || this.hareline[el.hl_id].hl_hare == null) {
                this.hareline[el.hl_id].hl_hare = el.mb_hashname;
              }
              else {
                this.hareline[el.hl_id].hl_hare = this.hareline[el.hl_id].hl_hare + "," + el.mb_hashname;
              }
            }

            if (el.hs_type === "S") {
              this.hareline[el.hl_id].hl_sribe = el.mb_hashname;
            }

            if (this.hareline[el.hl_id][el.hs_id][el.mb_id] === undefined || this.hareline[el.hl_id][el.hs_id][el.mb_id] === null) {
              this.hareline[el.hl_id][el.hs_id][el.mb_id] = [];
            }
            this.hareline[el.hl_id][el.hs_id][el.mb_id].mb_id = el.mb_id;
            this.hareline[el.hl_id][el.hs_id][el.mb_id].mb_hashname = el.mb_hashname;
            this.hareline[el.hl_id][el.hs_id][el.mb_id].mb_firstname = el.mb_firstname;
            this.hareline[el.hl_id][el.hs_id][el.mb_id].mb_lastname = el.mb_lastname;
            this.hareline[el.hl_id][el.hs_id][el.mb_id].mb_formalname = el.mb_formalname;
            this.hareline[el.hl_id][el.hs_id][el.mb_id].mb_email_id = el.mb_email_id;
            this.hareline[el.hl_id][el.hs_id][el.mb_id].mb_birthdate = el.mb_birthdate;
            this.hareline[el.hl_id][el.hs_id][el.mb_id].st_id = el.st_id;
            this.hareline[el.hl_id][el.hs_id][el.mb_id].mb_photo = el.mb_photo;
            this.hareline[el.hl_id][el.hs_id][el.mb_id].mb_contact_mobile = el.mb_contact_mobile;

            if (el.hl_datetime >= this.presentMonth) {
              this.tmp_hareline_future[el.hl_id] = this.hareline[el.hl_id];
            }
            else {
              this.tmp_hareline_past[el.hl_id] = this.hareline[el.hl_id];
            }
          });

          this.tmp_hareline_future.sort(function (a, b) {
            return new Date(a.hl_datetime) as any - <any>new Date(b.hl_datetime);
          });
          this.keys_future = Object.keys(this.tmp_hareline_future);

          this.tmp_hareline_past.sort(function (a, b) {
            return new Date(b.hl_datetime) as any - <any>new Date(a.hl_datetime);
          });
          this.keys_past = Object.keys(this.tmp_hareline_past);

          this.hareline_future = this.tmp_hareline_future;
          this.hareline_past = this.tmp_hareline_past;
        });
    });
  }

  private ngOnDestroy() {
    console.log("HarelinePage ngOnDestroy");
    this.hareline$ = null;
  }

  private addHareline() {
    console.log("HarelinePage addHareline");
    this.navCtrl.push(HarelineAddPage);
  }

  private viewHareline(hareline: Hareline) {
    console.log("HarelinePage viewHareline");

    this.navCtrl.push(HarelineViewPage, {
      "hareline": this.hareline_all.filter(data => data.hl_runno == hareline.hl_runno),
    });
  }

  private togglePast() {
    console.log("HarelinePage togglePast");
    if (this.showPast === true) { this.showPast = false; } else { this.showPast = true; }
    this.zippedPast = !this.zippedPast;
  }
  private toggleFuture() {
    console.log("HarelinePage toggleFuture");
    if (this.showFuture === true) { this.showFuture = false; } else { this.showFuture = true; }
    this.zippedFuture = !this.zippedFuture;
  }
}



// WEBPACK FOOTER //
// ./src/pages/hareline/hareline.ts